import BaseCompanyScopeEntityDto from '@/models/Shared/BaseCompanyScopeEntityDto';
import AgencyUserDto from '@/models/AgencyUsers/AgencyUserDto';
import BranchDto from '@/models/Branches/BranchDto';
import GeneralStatus from '@/models/Shared/GeneralStatus';
import InvoiceType from './InvoiceType';

export default class InvoiceDto extends BaseCompanyScopeEntityDto {
    type: InvoiceType = InvoiceType.Temp;
    status = 0;
    sequenceNumber = 0;
    periodType = 2;
    weekCommencingDate: Date | null = null;
    earliestTimesheetStartAt: Date = new Date();
    latestTimesheetStartAt: Date = new Date();
    desks: any[] = []; // Replace with actual DeskDto when available
    positions: any[] = []; // Replace with actual PositionDto when available
    locations: any[] = []; // Replace with actual LocationDto when available
    purchaseOrderNumber = '';
    number = '';
    externalAccountingSystemId = '';
    externalAccountingLocationId: string | null = null;
    externalAccountingLocation: any = null; // Replace with actual LocationDto when available
    invoiceLineSuffix = '';
}
